import React, { Dispatch, SetStateAction } from 'react'
import Popup from '../../../../../components/Popup'
import { Box, Typography } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import ButtonDefault from '../../../../../components/ButtonDefault'

type ConjointModifImpossibleRibPopinProps = {
	open: boolean
	setOpen: Dispatch<SetStateAction<boolean>>
}

const ConjointModifImpossibleRibPopin: React.FC<ConjointModifImpossibleRibPopinProps> = (
	{
		open,
		setOpen
	}
) => {

	const intl = useIntl()

	return (
		<Popup open={open} setOpen={setOpen} title={intl.formatMessage({ id: 'personalInfo.bankInfo.popinConjoint.title' })}>
			<Typography variant="body2" >
				<FormattedMessage id="personalInfo.bankInfo.popinConjoint.body" />
			</Typography>
			<Box display="flex" justifyContent="center">
				<ButtonDefault
					type="submit"
					variant="contained"
					onClick={() => setOpen(false)}
				>
					<FormattedMessage id="global.button.close" />
				</ButtonDefault>
			</Box>
		</Popup>
	)
}

export default (ConjointModifImpossibleRibPopin)
